import { ContentBox } from "@msuite/ui/app-shell";
import { DataTable } from "@msuite/ui/table";
import { columns } from "./table-config";
import { useFileInbox } from "./use-file-inbox";

/**
 * Every file somebody dragged onto the window that nothing could file, and the way to file it.
 *
 * Without this page such a file is unreachable. The explorer mounts against one parent entity at a
 * time and the three `GET /files/*` routes address a batch, a parent or a single id — none of which
 * a file with no parent has. The pill at the bottom of the window says how many were left behind;
 * this is where they are.
 */
export function FileInbox() {
	/** Query */
	const { files, isLoading, queryKey, refetch } = useFileInbox();

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={files}
				columns={columns}
				isLoading={isLoading}
				refetch={refetch}
				queryKey={queryKey}
				menu={null}
				persistenceKey="file-inbox-table"
			/>
		</ContentBox>
	);
}
